// extracted by mini-css-extract-plugin
export default {"main":"pageTemplate_main__-Yq4Q"};